/** Taking the operator to a part of the person record: scroll it into view and move the
 *  focus there — the number keys, the band's Trips cell, an old tab link (`/contacts`,
 *  `/invitations`), Reachability's "Contact ›".
 *
 *  A revealed element carries `data-revealed` until it loses the focus, so a target that is
 *  focusable only by script (`tabIndex={-1}`) can ring itself for that visit alone — a
 *  click into it later does not (`:focus-visible` would stay dark after a pointer click,
 *  which is how most reveals start). */
import { prefersReducedMotion } from '@/features/records/page/recordPage';

export function revealElement(el: HTMLElement, block: ScrollLogicalPosition = 'start'): void {
  el.scrollIntoView?.({ block, behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
  el.setAttribute('data-revealed', '');
  el.addEventListener('blur', () => el.removeAttribute('data-revealed'), { once: true });
  el.focus({ preventScroll: true });
}

/** Reveal the element with this id; false when it is not on the page (yet). */
export function focusAnchor(id: string): boolean {
  const el = document.getElementById(id);
  if (!el) return false;
  revealElement(el);
  return true;
}
